import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import {
  Label,
  Select,
} from '@bingads-webui-react/primitive';

export function EditPrimaryContact({
  contacts,
  selected,
  warning,
  onSelect,
  onSubmit,
  onCancel,
  i18n,
}) {
  return (
    <div className="panel form-horizontal">
      <div className="panel-heading">
        <div className="panel-title">
          {i18n.getString('Account_PrimaryContact_SectionTitle_Edit')}
        </div>
      </div>
      <div className="panel-body">
        <div className="row">
          <div className="col-sm-8">
            <div className="form-group">
              <div className="col-sm-12">
                <div className="form-control-static">
                  {i18n.getString('Account_PrimaryContact_IntroductionText')}
                </div>
              </div>
            </div>
            <div className="form-group" id="primary-contact-dropdown-container">
              <Label className="col-xs-3">
                {i18n.getString('Account_PrimaryContactLabel')}
                <span><HelpPopup topic="pop_BA_Accounts_Index_PrimaryContact" /></span>
              </Label>
              <div className="col-xs-6">
                <Select
                  disabled={!_.isEmpty(warning)}
                  className="primary-contact-dropdown"
                  onChange={event => onSelect(event.currentTarget.value)}
                  value={_.isEmpty(selected) ? '' : selected.Value}
                >
                  {
                    _.map(contacts, contact => (
                      <option key={contact.Value} value={contact.Value}>{contact.Text}</option>))
                  }
                </Select>
              </div>
            </div>
          </div>
        </div>
        {
          !_.isEmpty(warning) && (
            <div id="primary-contact-warning">
              <div className="alert alert-warning">
                <span className="alert-image" />
                {warning}
              </div>
            </div>
          )
        }
      </div>
      <div className="panel-footer">
        <button className="btn btn-primary edit-primary-submit" onClick={() => onSubmit()} disabled={!_.isEmpty(warning)}>
          {i18n.getString('SaveLabel')}
        </button>
        <button className="btn btn-default edit-primary-cancel" onClick={() => onCancel()}>
          {i18n.getString('CancelLabel')}
        </button>
      </div>
    </div>
  );
}

EditPrimaryContact.propTypes = {
  selected: PropTypes.shape({
    Text: PropTypes.string.isRequired,
    Value: PropTypes.string.isRequired,
  }),
  contacts: PropTypes.arrayOf(PropTypes.shape({
    Text: PropTypes.string.isRequired,
    Value: PropTypes.string.isRequired,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  warning: PropTypes.string,
};

EditPrimaryContact.defaultProps = {
  warning: '',
  selected: null,
};
